import { render, staticRenderFns } from "./AI-Menu.vue?vue&type=template&id=3908ed37&scoped=true&"
import script from "./AI-Menu.vue?vue&type=script&lang=js&"
export * from "./AI-Menu.vue?vue&type=script&lang=js&"
import style0 from "./AI-Menu.vue?vue&type=style&index=0&id=3908ed37&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3908ed37",
  null
  
)

export default component.exports